<template>
  <v-expansion-panel style="border-radius: 6px">
    <v-expansion-panel-header
      style="font-weight: 600; color: #746b6b; font-size: 12x"
    >
      {{ $t("events.event-config.event-grouper") }}
    </v-expansion-panel-header>
    <v-expansion-panel-content class="py-6">
      <v-row>
        <v-col cols="12" class="pt-0 pb-0">
          <v-checkbox
            v-model="
              $produtos_gerenciar.cadastro.dados_cadastrais.prod_agrupamento
            "
            :label="$t('events.event-config.enable-event-grouper')"
          >
          </v-checkbox>
        </v-col>
      </v-row>
      <v-row v-if="hasCustom" class="mt-0">
        <v-col cols="12" class="pt-0">
          <v-checkbox
            v-model="
              $produtos_gerenciar.cadastro.dados_cadastrais.exibe_agrupamento
            "
            :label="$t('events.event-config.group-events-home')"
          >
          </v-checkbox>
        </v-col>
        <v-col cols="12">
          <BaseAutocomplete
            v-model="
              $produtos_gerenciar.cadastro.dados_cadastrais.nidprod_agrupamento
            "
            :items="Events"
            :label="$t('events.title')"
            :filter="searchForm"
            chips
            color="blue-grey lighten-2"
            item-text="descricao"
            item-value="id"
            multiple
            needSelection
            :no-data-text="$t('events.no-events-found')"
            :required="requiredProd"
          >
            <template v-slot:selection="{ item }">
              {{ item.descricao }},
            </template>
            <template v-slot:item="{ item }">
              {{ item.descricao }}
            </template>
          </BaseAutocomplete>
        </v-col>
      </v-row>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import mixins from "@/mixins";
import _ from "lodash";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "EventGrouper",
  mixins: [mixins],
  components: {
    BaseAutocomplete: () => import("@/components/forms/BaseAutocomplete.vue"),
  },
  data() {
    return {
      options5: {
        locale: "pt-BR",
        suffix: "UTC-3",
      },
      resultado: [],
    };
  },
  watch: {
    "$produtos_gerenciar.cadastro.dados_cadastrais.prod_agrupamento"(e) {
      if (e == 1) {
        this.getCombos();
        this.$produtos_gerenciar.filtroProdutos();
      }
    },
    "$produtos_gerenciar.produtos"() {
      this.resultado = this.$produtos_gerenciar.produtos.concat(this.combos);
      this.resultado = this.resultado.map(objeto => {
        return {
          id: objeto.idproduto ? objeto.idproduto : objeto.idcombo,
          ...objeto,
        };
      });
    },
    combos() {
      this.resultado = this.$produtos_gerenciar.produtos.concat(this.combos);
      this.resultado = this.resultado.map(objeto => {
        return {
          id: objeto.idproduto ? objeto.idproduto : objeto.idcombo,
          ...objeto,
        };
      });
    },
  },
  methods: {
    ...mapActions(["getCombos"]),
    replaceSpecialChars(str) {
      str = str.replace(/[ÀÁÂÃÄÅ]/, "A");
      str = str.replace(/[àáâãäå]/, "a");
      str = str.replace(/[ÈÉÊË]/, "E");
      str = str.replace(/[Ç]/, "C");
      str = str.replace(/[ç]/, "c");
      // o resto
      return str.replace(/[^a-z0-9]/gi, "");
    },
    searchForm(array, search) {
      let pesquisa = this.replaceSpecialChars(
        search.toString().toLocaleLowerCase().normalize("NFD")
      );
      let palavra = this.replaceSpecialChars(
        array.descricao.toString().toLocaleLowerCase().normalize("NFD")
      );

      if (palavra.indexOf(pesquisa) != -1) {
        return array;
      }
    },
  },
  computed: {
    ...mapGetters(["combos"]),
    hasCustom() {
      return this.$produtos_gerenciar.cadastro.dados_cadastrais
        .prod_agrupamento;
    },
    Events() {
      return _.orderBy(
        this.resultado,
        [resultado => resultado?.descricao?.toLocaleLowerCase()],
        ["descricao"]
      );
    },
    requiredProd() {
      return this.$produtos_gerenciar.cadastro.dados_cadastrais
        .prod_agrupamento;
    },
  },
  mounted() {
    if (this.$produtos_gerenciar.cadastro.dados_cadastrais.prod_agrupamento) {
      this.getCombos();
      this.$produtos_gerenciar.filtroProdutos();
    }
  },
};
</script>

<style>
.active-class {
  background-color: #e6f7ff !important;
  border-color: #91d5ff !important;
  color: #1890ff !important;
}
</style>
